module.exports = __webpack_public_path__ + "static/media/munchUp.db3e8f38.jpg";